import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-[#0F172A] mb-4 pb-2 border-b border-[#E2E8F0]">
      {title}
    </h2>
    <div className="text-[#475569] leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Header */}
      <div className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="text-[#0596DE] hover:underline text-sm">
            ← Retour à l'accueil
          </Link>
          <h1 className="text-3xl font-bold text-[#0F172A] mt-4">
            Mentions légales & Conditions Générales d'Utilisation
          </h1>
          <p className="text-[#64748B] mt-2 text-sm">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">

        {/* MENTIONS LÉGALES */}
        <div className="bg-white rounded-2xl shadow-sm border border-[#E2E8F0] p-8 mb-8">
          <h2 className="text-2xl font-bold text-[#0596DE] mb-8">Mentions légales</h2>

          <Section title="1. Éditeur du site">
            <p>Le site <strong>Tabbibak.dz</strong> (accessible à l'adresse <strong>tabbibak.com</strong>) est édité par :</p>
            <ul className="list-none space-y-1 mt-2">
              <li>• <strong>Dénomination :</strong> Tabbibak.dz</li>
              <li>• <strong>Siège social :</strong> Algérie</li>
              <li>• <strong>Email :</strong> contact@tabbibak.com</li>
              <li>• <strong>Directeur de la publication :</strong> Nadjib Mokdad</li>
            </ul>
          </Section>

          <Section title="2. Hébergement">
            <p>Le site est hébergé par :</p>
            <ul className="list-none space-y-1 mt-2">
              <li>• <strong>Frontend :</strong> Vercel Inc. — 340 Pine Street, Suite 701, San Francisco, CA 94104, États-Unis</li>
              <li>• <strong>Backend :</strong> Render Inc. — San Francisco, Californie, États-Unis</li>
              <li>• <strong>Base de données :</strong> MongoDB Atlas (cloud)</li>
            </ul>
          </Section>

          <Section title="3. Propriété intellectuelle">
            <p>
              L'ensemble du contenu de ce site (textes, images, logos, structure, code source) est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, est interdite sans autorisation écrite préalable de Tabbibak.dz.
            </p>
          </Section>

          <Section title="4. Données personnelles">
            <p>
              Tabbibak.dz collecte des données personnelles dans le cadre de l'utilisation de la plateforme (nom, email, numéro de téléphone, historique de rendez-vous). Ces données sont utilisées exclusivement pour le fonctionnement du service et ne sont jamais vendues à des tiers.
            </p>
            <p>
              Conformément à la loi n° 18-07 du 10 juin 2018 relative à la protection des personnes physiques dans le traitement des données à caractère personnel, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en contactant : <strong>contact@tabbibak.com</strong>
            </p>
          </Section>

          <Section title="5. Cookies">
            <p>
              Le site utilise des cookies techniques essentiels au fonctionnement du service (authentification, préférences de langue). Ces cookies ne contiennent aucune information personnelle et ne sont pas utilisés à des fins publicitaires.
            </p>
          </Section>
        </div>

        {/* CGU */}
        <div className="bg-white rounded-2xl shadow-sm border border-[#E2E8F0] p-8">
          <h2 className="text-2xl font-bold text-[#0596DE] mb-8">Conditions Générales d'Utilisation (CGU)</h2>

          <Section title="1. Objet">
            <p>
              Les présentes Conditions Générales d'Utilisation régissent l'accès et l'utilisation de la plateforme Tabbibak.dz, service de mise en relation entre patients et professionnels de santé en Algérie.
            </p>
          </Section>

          <Section title="2. Inscription et compte utilisateur">
            <p>L'utilisation du service nécessite la création d'un compte. L'utilisateur s'engage à :</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Fournir des informations exactes et à jour</li>
              <li>Maintenir la confidentialité de ses identifiants</li>
              <li>Ne pas créer plusieurs comptes avec la même identité</li>
              <li>Signaler immédiatement toute utilisation non autorisée de son compte</li>
            </ul>
          </Section>

          <Section title="3. Utilisation du service">
            <p>
              Tabbibak.dz est une plateforme de <strong>prise de rendez-vous médicaux</strong>. Le service ne constitue en aucun cas une consultation médicale, un diagnostic ou un avis médical.
            </p>
            <p>
              En cas d'urgence médicale, l'utilisateur doit contacter le <strong>SAMU (15)</strong> ou se rendre aux urgences de l'hôpital le plus proche.
            </p>
          </Section>

          <Section title="4. Obligations des patients">
            <ul className="list-disc list-inside space-y-1">
              <li>Se présenter aux rendez-vous confirmés à l'heure prévue</li>
              <li>Annuler tout rendez-vous au moins 24h à l'avance en cas d'empêchement</li>
              <li>Fournir des informations de santé exactes lors de la prise de rendez-vous</li>
              <li>Ne pas utiliser la plateforme à des fins frauduleuses</li>
            </ul>
          </Section>

          <Section title="5. Obligations des médecins">
            <ul className="list-disc list-inside space-y-1">
              <li>Être titulaire d'un diplôme médical reconnu en Algérie</li>
              <li>Respecter les rendez-vous confirmés</li>
              <li>Maintenir à jour leurs disponibilités sur la plateforme</li>
              <li>Respecter le secret médical et la confidentialité des données patients</li>
              <li>Ne pas utiliser la plateforme pour des activités contraires à la déontologie médicale</li>
            </ul>
          </Section>

          <Section title="6. Abonnement médecin">
            <p>
              L'accès aux fonctionnalités de gestion de cabinet (prise de RDV en ligne, salle d'attente virtuelle, dossiers patients) est soumis à un abonnement mensuel de <strong>2 500 DZD/mois</strong> après une période d'essai gratuite de 2 mois.
            </p>
            <p>
              Le paiement s'effectue via Chargily Pay (CIB / BaridiMob). Aucun remboursement n'est accordé pour les périodes déjà facturées.
            </p>
          </Section>

          <Section title="7. Responsabilité">
            <p>
              Tabbibak.dz est une plateforme d'intermédiation et ne peut être tenu responsable de la qualité des soins dispensés par les médecins référencés, des annulations ou absences aux rendez-vous, ni des informations médicales échangées entre médecin et patient.
            </p>
            <p>
              La plateforme s'engage à assurer la disponibilité du service dans la mesure du possible, sans garantir une continuité ininterrompue.
            </p>
          </Section>

          <Section title="8. Contenu interdit">
            <p>Il est strictement interdit d'utiliser la plateforme pour :</p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>Diffuser des informations médicales fausses ou trompeuses</li>
              <li>Harceler ou menacer d'autres utilisateurs</li>
              <li>Tenter d'accéder frauduleusement au système informatique</li>
              <li>Publier des avis frauduleux ou diffamatoires</li>
            </ul>
          </Section>

          <Section title="9. Suspension et résiliation">
            <p>
              Tabbibak.dz se réserve le droit de suspendre ou supprimer tout compte en cas de violation des présentes CGU, sans préavis et sans indemnité.
            </p>
            <p>
              L'utilisateur peut supprimer son compte à tout moment en contactant <strong>contact@tabbibak.com</strong>. Ses données personnelles seront supprimées dans un délai de 30 jours.
            </p>
          </Section>

          <Section title="10. Modifications des CGU">
            <p>
              Tabbibak.dz se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront notifiés par email de toute modification substantielle. La poursuite de l'utilisation du service après notification vaut acceptation des nouvelles conditions.
            </p>
          </Section>

          <Section title="11. Droit applicable">
            <p>
              Les présentes CGU sont régies par le droit algérien. En cas de litige, les parties s'engagent à rechercher une solution amiable avant tout recours judiciaire. À défaut, les tribunaux algériens seront compétents.
            </p>
          </Section>

          <Section title="12. Contact">
            <p>Pour toute question relative aux présentes CGU ou à vos données personnelles :</p>
            <ul className="list-none space-y-1 mt-2">
              <li>• <strong>Email :</strong> contact@tabbibak.com</li>
              <li>• <strong>Site :</strong> tabbibak.com/contact</li>
            </ul>
          </Section>
        </div>

        {/* Footer note */}
        <p className="text-center text-[#94A3B8] text-xs mt-8">
          © {new Date().getFullYear()} Tabbibak.dz — Tous droits réservés
        </p>
      </div>
    </div>
  );
}